import { KpiMetricValue } from './kpi-metric-value'
import { KpiMetricValueQuery } from './kpi-metric-value-query'
import { KpiMetricValueMutation } from './kpi-metric-value-mutation'

export const entities = [KpiMetricValue]
export const resolvers = [KpiMetricValueQuery, KpiMetricValueMutation]
export const subscribers = []
